export const doesHttpOnlyCookieExist = (cookieName) => {
  const date = new Date();
  date.setTime(date.getTime() + 1000);
  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${cookieName}=new_value;path=/;${expires}`;

  return document.cookie.indexOf(`${cookieName}=`) === -1;
};

export const getCookie = (name) => {
  const nameLengthPlus = name.length + 1;
  return (
    document.cookie
      .split(";")
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLengthPlus) === `${name}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLengthPlus));
      })[0] || null
  );
};

export const deleteCookie = (name) => {
  const date = new Date();

  // Set it expire in -1 days
  date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

  document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
};
